<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <!-- VOXTELL: fallback mark when LOGO_THUMBNAIL is unset (upstream ships its own bubble) -->
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#8a05ff">
      <path
        d="M93.2298 67.586H92.3132H91.3691H82.2485C81.4707 75.0435 75.1655 80.855 67.5024 80.855H65.732L53.2055 95.1572V80.855H47.2198C39.0303 80.855 32.3925 74.2173 32.3925 66.0277C32.3925 57.8382 39.0303 51.2005 47.2198 51.2005H58.3766V39.863C58.3766 38.7669 58.3766 37.9393 58.3766 36.6953H47.6533C31.2782 36.6953 18 49.9695 18 66.3486C18 82.7276 31.2755 96.0031 47.6533 96.0031H67.0624C82.2983 96.0031 94.8523 84.5111 96.5258 69.7205L93.2298 67.586Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M101.776 31C106.671 31 110.64 34.9678 110.64 39.8639V55.4494C110.64 59.7013 107.647 63.2539 103.653 64.1142L103.786 69.5499C103.793 69.8354 103.564 70.0711 103.278 70.0711C103.181 70.0711 103.086 70.0436 103.003 69.9899L94.1956 64.329L91.3837 64.3133H91.375H70.5201C65.6253 64.3133 61.6562 60.3442 61.6562 55.4494V39.8639C61.6562 34.9691 65.624 31 70.5201 31H101.776ZM75.2211 43.6181C72.9951 43.6181 71.1919 45.4212 71.1919 47.6473C71.1919 49.8721 72.9951 51.6766 75.2211 51.6766C77.4472 51.6766 79.2505 49.8721 79.2505 47.6473C79.2505 45.4225 77.4472 43.6181 75.2211 43.6181ZM86.1475 43.6181C83.9227 43.6181 82.1184 45.4212 82.1182 47.6473C82.1182 49.8721 83.9214 51.6766 86.1475 51.6766C88.3736 51.6766 90.1768 49.8721 90.1768 47.6473C90.1768 45.4225 88.3723 43.6181 86.1475 43.6181ZM97.0739 43.6181C94.849 43.6181 93.0446 45.4212 93.0446 47.6473C93.0446 49.8721 94.849 51.6766 97.0739 51.6766C99.2987 51.6766 101.103 49.8721 101.103 47.6473C101.103 45.4225 99.2987 43.6181 97.0739 43.6181Z"
      />
    </g>
  </svg>
</template>
